import React from 'react';
import { FaYoutube, FaInstagram } from 'react-icons/fa6';
import dinarMbk from '../assets/dinar_mbk.png';

const YOUTUBE_URL = 'https://www.youtube.com/@surthrivaling';
const INSTAGRAM_URL = 'https://www.instagram.com/surthrivaling';
const EMAIL = 'hello@surthrivaling.com';

function Contact() {
  return (
    <section id="contact" className="section contact">
      <div className="container">
        <div className="contact__layout reveal">
          <div className="contact__content">
            <header className="contact__header">
              <h2 className="section__title">Contact</h2>
              <p className="section__subtitle">
              If you&rsquo;re thinking of heading on a similar journey of discovery, want to partner up, or just want to chat shit, feel free to drop me a line.
              </p>
            </header>

            <a href={`mailto:${EMAIL}`} className="contact__email">
              {EMAIL}
            </a>

            <div className="contact__buttons">
              <a
                href={YOUTUBE_URL}
                className="btn btn--accent contact__btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube aria-hidden="true" />
                YouTube
              </a>
              <a
                href={INSTAGRAM_URL}
                className="btn btn--outline contact__btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram aria-hidden="true" />
                Instagram
              </a>
            </div>
          </div>

          <img
            src={dinarMbk}
            alt="Dinar in Bangkok"
            className="contact__photo"
          />
        </div>
      </div>
    </section>
  );
}

export default Contact;
